import { useContext } from 'react';

import { CookieConsentContext } from '@/hooks/CookieConsentContext';

export const useCookieConsent = () => useContext(CookieConsentContext);
